import { FormattedTime } from 'react-intl';

type Props = {
  value: string | number | Date | undefined;
} & Intl.DateTimeFormatOptions;

export const TTime = ({ value, ...props }: Props) => {
  return <FormattedTime {...props} value={value} />;
};
